/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Eyebrow_WhyInputs */

const en_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why Mark`)
};

const es_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por qué Mark`)
};

const de_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum Mark`)
};

const zh_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么 Mark`)
};

const ar_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لماذا Mark`)
};

const fr_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi Mark`)
};

const vi_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vì sao chọn Mark`)
};

const sw_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kwa nini Mark`)
};

const th_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำไมต้อง Mark`)
};

const bs_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zašto Mark`)
};

const ja_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜMarkなのか`)
};

const ko_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`왜 Mark`)
};

const pt_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que Mark`)
};

const it_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché Mark`)
};

const sv_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varför Mark`)
};

const nl_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom Mark`)
};

const da_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvorfor Mark`)
};

const nb_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvorfor Mark`)
};

const fi_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miksi Mark?`)
};

const pl_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dlaczego Mark`)
};

const ru_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Почему Mark`)
};

const tr_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neden Mark`)
};

const hi_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्यों Mark`)
};

const id_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengapa Mark`)
};

const ms_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengapa Mark`)
};

const cs_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proč Mark?`)
};

const el_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Γιατί Mark`)
};

const he_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`למה Mark`)
};

const af_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom Mark`)
};

const hu_home_eyebrow_why = /** @type {(inputs: Home_Eyebrow_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miért Mark`)
};

/**
* | output |
* | --- |
* | "Why Mark" |
*
* @param {Home_Eyebrow_WhyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_eyebrow_why = /** @type {((inputs?: Home_Eyebrow_WhyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Eyebrow_WhyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_eyebrow_why(inputs)
	if (locale === "de") return de_home_eyebrow_why(inputs)
	if (locale === "zh") return zh_home_eyebrow_why(inputs)
	if (locale === "ar") return ar_home_eyebrow_why(inputs)
	if (locale === "fr") return fr_home_eyebrow_why(inputs)
	if (locale === "vi") return vi_home_eyebrow_why(inputs)
	if (locale === "sw") return sw_home_eyebrow_why(inputs)
	if (locale === "th") return th_home_eyebrow_why(inputs)
	if (locale === "bs") return bs_home_eyebrow_why(inputs)
	if (locale === "ja") return ja_home_eyebrow_why(inputs)
	if (locale === "ko") return ko_home_eyebrow_why(inputs)
	if (locale === "pt") return pt_home_eyebrow_why(inputs)
	if (locale === "it") return it_home_eyebrow_why(inputs)
	if (locale === "sv") return sv_home_eyebrow_why(inputs)
	if (locale === "nl") return nl_home_eyebrow_why(inputs)
	if (locale === "da") return da_home_eyebrow_why(inputs)
	if (locale === "nb") return nb_home_eyebrow_why(inputs)
	if (locale === "fi") return fi_home_eyebrow_why(inputs)
	if (locale === "pl") return pl_home_eyebrow_why(inputs)
	if (locale === "ru") return ru_home_eyebrow_why(inputs)
	if (locale === "tr") return tr_home_eyebrow_why(inputs)
	if (locale === "hi") return hi_home_eyebrow_why(inputs)
	if (locale === "id") return id_home_eyebrow_why(inputs)
	if (locale === "ms") return ms_home_eyebrow_why(inputs)
	if (locale === "cs") return cs_home_eyebrow_why(inputs)
	if (locale === "el") return el_home_eyebrow_why(inputs)
	if (locale === "he") return he_home_eyebrow_why(inputs)
	if (locale === "af") return af_home_eyebrow_why(inputs)
	if (locale === "hu") return hu_home_eyebrow_why(inputs)
	return en_home_eyebrow_why(inputs)
});